import { createSlice } from '@reduxjs/toolkit';
import { INATS } from 'src/models/nats';
import natsService from 'src/services/NatsService';
import axios from "src/utils/axios";

interface INatsState {
    natsCredentials: INATS
}

const initialState: INatsState = {
    natsCredentials: {
        clientType: "",
        connection_status: false,
        url: "",
        clientId: null,
        username: "",
        password: null,
        allowedSubscriptions: [],
        id: "",
        port: null
    }
};

const slice = createSlice({
    name: 'nats',
    initialState,
    reducers: {
        getNatsDetails(state, action) {
            state.natsCredentials = action.payload;
        }
    }
});

export const reducer = slice.reducer;

const link = `${process.env.REACT_APP_API_URL}/aacl/api/v1/aacl/`;

export const getNatsCredentials = (VIEW_ALL_PARTICIPANT) => async (dispatch) => {
    try {
        const content = {
            clientType: "external",
            userData: {},
            content: ""
        };
        const response = await axios.post(`${link}client/authentication/nats/external`, content);
        natsService.getClient(response?.data?.data, dispatch, VIEW_ALL_PARTICIPANT);
        natsService.onMessage(dispatch);
        if (response?.data?.status) {
            // Heartbeat can stay if server requires it, but let's keep it silent
            setInterval(() => {
                natsService.publish("123456", "connection");
            }, 25000);
        }
    } catch (error) {
        throw new Error(error);
    }
};

export default slice;
